/* ==========================================================================
   Quiero+ · Página del programa de puntos (sección qn-quiero-mas)
   --------------------------------------------------------------------------
   1. Botones [data-qm-open="register|account|redeem|referral|home|show"]
      - Si Clientif expone window.Clientif.open(vista), abren el modal.
      - Si no (hoy), muestran una flecha que señala el botón flotante de
        Clientif (#clientif-widget), abajo a la derecha.
   2. Aviso suave al entrar a la página (se puede apagar desde el editor).
   3. Links con #sumarme #canjear #invitar #mis-puntos #abrir hacen lo mismo
      al cargar la página (sirve para mandar el link por WhatsApp o mail).
   4. Calculadora, pestañas de la réplica del modal y sincronización opcional
      con la API pública de Clientif.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__qmQuieroMas) return;
  window.__qmQuieroMas = true;

  var API = 'https://api.clientif.com';
  var HASH_VIEWS = { sumarme: 'register', abrir: 'home', 'quiero-mas': 'home', canjear: 'redeem', invitar: 'referral', 'mis-puntos': 'account' };
  var ARROW =
    '<svg class="qm-coach__arrow" viewBox="0 0 74 54" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M7 4C18 28 38 43 64 46" stroke="#fff" stroke-width="7" stroke-linecap="round"/>' +
    '<path d="M54 36l11 10-12 6" stroke="#fff" stroke-width="7" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M7 4C18 28 38 43 64 46" stroke="#1F3A26" stroke-width="3" stroke-linecap="round"/>' +
    '<path d="M54 36l11 10-12 6" stroke="#1F3A26" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function fmt(n) { n = Math.round(Number(n) || 0); return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function mem(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) { return null; } return null; }
  function esc(s) { return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------- botón flotante de Clientif ---------- */
  function launcher() { return document.getElementById('clientif-widget'); }
  function launcherVisible(l) {
    if (!l) return false;
    var cs = window.getComputedStyle(l);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = l.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function widgetIsOpen() {
    var l = launcher();
    if (!l) return false;
    var r = l.getBoundingClientRect();
    return r.width > 240 && r.height > 300;   // cerrado: ~158×146 · abierto: 350×650 o pantalla completa
  }
  function clientifApi() { var c = window.Clientif; return c && typeof c.open === 'function' ? c : null; }

  /* ---------- aviso con flecha ---------- */
  var coach, ring, hideTimer, loudTimer, txt = {};

  function buildCoach(root) {
    var d = root.dataset;
    txt = { title: d.hintTitle, text: d.hintText, loudTitle: d.hintLoudTitle, loudText: d.hintLoudText, close: d.hintClose || 'Cerrar' };
    coach = document.createElement('div');
    coach.className = 'qm-coach';
    coach.hidden = true;
    coach.setAttribute('role', 'status');
    coach.innerHTML = '<div class="qm-coach__bubble"><strong></strong><span></span>' +
      '<button type="button" class="qm-coach__close">&times;</button></div>' + ARROW;
    coach.querySelector('.qm-coach__close').setAttribute('aria-label', txt.close);
    ring = document.createElement('div');
    ring.className = 'qm-ring';
    ring.hidden = true;
    ring.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ring);
    document.body.appendChild(coach);
    coach.querySelector('.qm-coach__close').addEventListener('click', function () { hideCoach(true); });
    window.addEventListener('resize', place, { passive: true });
    window.addEventListener('orientationchange', place);
  }

  function place() {
    if (!coach || coach.hidden) return;
    var l = launcher();
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var tx, ty, r, hasTarget = launcherVisible(l) && !widgetIsOpen();
    if (hasTarget) {
      r = l.getBoundingClientRect();
      tx = r.left + r.width * 0.595;   // centro aproximado de las hojitas
      ty = r.top + r.height * 0.54;
    } else {
      tx = vw - 60;
      ty = vh - 74;
    }
    var above = hasTarget && vw < 600;   // en celular el aviso va arriba del botón, no a la izquierda
    coach.classList.toggle('qm-coach--above', above);
    if (above) {
      var gap = Math.max(8, vw - r.right + 4);
      coach.style.right = gap + 'px';
      coach.style.bottom = Math.max(8, vh - r.top + 2) + 'px';
      coach.style.setProperty('--qm-coach-w', Math.min(250, vw - gap - 16) + 'px');
      coach.style.setProperty('--qm-caret', Math.max(14, (vw - gap) - tx - 7) + 'px');
    } else {
      coach.style.right = Math.max(6, vw - (tx - 26)) + 'px';
      coach.style.bottom = Math.max(6, vh - (ty + 10)) + 'px';
      coach.style.setProperty('--qm-coach-w', Math.max(150, Math.min(250, tx - 26 - 58 - 12)) + 'px');
    }
    ring.style.left = (tx - 38) + 'px';
    ring.style.top = (ty - 38) + 'px';
    ring.hidden = !hasTarget;
  }

  function showCoach(loud) {
    if (!coach || widgetIsOpen()) return;
    clearTimeout(hideTimer);
    coach.querySelector('strong').textContent = loud ? txt.loudTitle : txt.title;
    coach.querySelector('span').textContent = loud ? txt.loudText : txt.text;
    coach.hidden = false;
    place();
    coach.classList.remove('is-loud');
    void coach.offsetWidth; // reinicia la animación
    if (loud) {
      coach.classList.add('is-loud');
      clearTimeout(loudTimer);
      loudTimer = setTimeout(function () { coach.classList.remove('is-loud'); }, 4500);
    }
    window.requestAnimationFrame(function () {
      coach.classList.add('is-on');
      if (!ring.hidden) ring.classList.add('is-on');
    });
  }

  function hideCoach(dismiss) {
    if (!coach) return;
    coach.classList.remove('is-on', 'is-loud');
    ring.classList.remove('is-on');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      if (!coach.classList.contains('is-on')) { coach.hidden = true; ring.hidden = true; }
    }, 380);
    if (dismiss) mem('qm-hint-off', '1');
  }

  /* Mira el iframe de Clientif: si se agranda es que el modal se abrió. */
  function watchLauncher(tries) {
    var l = launcher();
    if (!l) {
      if (tries < 40) setTimeout(function () { watchLauncher(tries + 1); }, 500);
      return;
    }
    var seenClosed = false;
    var check = function () {
      if (widgetIsOpen()) {
        if (seenClosed) mem('qm-opened', '1');   // solo si lo vimos pasar de cerrado a abierto
        hideCoach(false);
      } else {
        seenClosed = true;
        place();
      }
    };
    if (window.ResizeObserver) new ResizeObserver(check).observe(l);
    if (window.MutationObserver) new MutationObserver(check).observe(l, { attributes: true, attributeFilter: ['style', 'class'] });
    check();
  }

  /* ---------- abrir Quiero+ ---------- */
  function openProgram(view) {
    if (view !== 'show') {
      var api = clientifApi();
      if (api) {
        try { api.open(view || 'home'); hideCoach(false); return; } catch (e) { /* sigue con la flecha */ }
      }
    }
    showCoach(true);
  }

  /* ---------- calculadora ---------- */
  function initCalc(root) {
    var calc = root.querySelector('[data-qm-calc]');
    if (!calc) return null;
    var range = calc.querySelector('[data-qm-range]');
    var btns = Array.prototype.slice.call(calc.querySelectorAll('[data-rate]'));
    if (!range || !btns.length) return null;
    var q = function (s) { return calc.querySelector(s); };
    var amount = q('[data-qm-amount]'), outPts = q('[data-qm-out-pts]'), outMoney = q('[data-qm-out-money]');
    var outYear = q('[data-qm-out-year]'), outCmp = q('[data-qm-out-cmp]');
    var sel = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0];

    function update() {
      var v = Number(range.value) || 0;
      var min = Number(range.min) || 0, max = Number(range.max) || 1;
      var rate = Number(sel.getAttribute('data-rate')) || 0;
      var pts = Math.round(v * rate / 100);
      var top = btns.reduce(function (a, b) { return Number(b.getAttribute('data-rate')) > Number(a.getAttribute('data-rate')) ? b : a; });
      amount.textContent = fmt(v);
      outPts.textContent = fmt(pts);
      outMoney.textContent = fmt(pts);
      outYear.textContent = fmt(pts * 12);
      range.style.setProperty('--p', ((v - min) / (max - min) * 100) + '%');
      if (outCmp) {
        if (sel === top || Number(sel.getAttribute('data-rate')) >= Number(top.getAttribute('data-rate'))) {
          outCmp.textContent = outCmp.getAttribute('data-top') || '';
        } else {
          var topYear = Math.round(v * Number(top.getAttribute('data-rate')) / 100) * 12;
          outCmp.textContent = (outCmp.getAttribute('data-tpl') || '')
            .replace('{nivel}', top.getAttribute('data-level') || '')
            .replace('{monto}', fmt(topYear));
        }
      }
    }
    range.addEventListener('input', update);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        sel = b;
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        update();
      });
    });
    update();
    return update;
  }

  /* ---------- pestañas de la réplica del modal ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-qm-replica] [role="tab"]');
    each(tabs, function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        select(next); next.focus();
      });
    });
    function select(t) {
      each(tabs, function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
  }

  /* ---------- sincronización opcional con Clientif ---------- */
  function initLive(root, recalc) {
    var id = (root.getAttribute('data-store-id') || '').trim();
    if (!id || !window.fetch) return;
    var base = API + '/stores/' + encodeURIComponent(id) + '/';
    var get = function (p) {
      return fetch(base + p, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); });
    };
    get('levels').then(function (levels) {
      if (!Array.isArray(levels) || !levels.length) return;
      var rates = [];
      levels.forEach(function (l) {
        if (l.isActive === false) return;
        rates.push(Number(l.cashbackRate));
        var li = root.querySelector('[data-qm-level="' + esc(l.name) + '"]');
        if (li) {
          each(li.querySelectorAll('[data-qm-lv-rate]'), function (e) { e.textContent = l.cashbackRate; });
          var need = li.querySelector('[data-qm-lv-need]');
          if (need) need.textContent = fmt(l.necessaryPoints);
        }
        var b = root.querySelector('[data-qm-calc] [data-level="' + esc(l.name) + '"]');
        if (b) { b.setAttribute('data-rate', l.cashbackRate); var sp = b.querySelector('span'); if (sp) sp.textContent = l.cashbackRate + '%'; }
      });
      if (rates.length) {
        each(root.querySelectorAll('[data-qm-rate-min]'), function (e) { e.textContent = Math.min.apply(null, rates); });
        each(root.querySelectorAll('[data-qm-rate-max]'), function (e) { e.textContent = Math.max.apply(null, rates); });
      }
      if (recalc) recalc();
    }).catch(function () {});
    get('public-ways-to-earn').then(function (list) {
      if (!Array.isArray(list)) return;
      list.forEach(function (w) {
        var pts = fmt(w.pointsToReward);
        each(root.querySelectorAll('[data-qm-code="' + esc(w.code) + '"] [data-qm-pts]'), function (e) { e.textContent = pts; });
        if (w.code === 'ReferralSignupReward') each(root.querySelectorAll('[data-qm-ref-friend]'), function (e) { e.textContent = pts; });
        if (w.code === 'ReferralPurchaseReward') each(root.querySelectorAll('[data-qm-ref-you]'), function (e) { e.textContent = pts; });
      });
    }).catch(function () {});
    get('public-redemption-settings').then(function (r) {
      if (r && r.minimumRedeemablePoints) each(root.querySelectorAll('[data-qm-min]'), function (e) { e.textContent = fmt(r.minimumRedeemablePoints); });
    }).catch(function () {});
  }

  /* ---------- arranque ---------- */
  function init() {
    var roots = document.querySelectorAll('[data-qm]');
    if (!roots.length) return;
    var root = roots[0];
    buildCoach(root);
    watchLauncher(0);

    each(roots, function (r) {
      var recalc = initCalc(r);
      initTabs(r);
      initLive(r, recalc);
      r.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-qm-open]') : null;
        if (!t) return;
        e.preventDefault();
        openProgram(t.getAttribute('data-qm-open'));
      });
    });

    /* link directo: /pages/quiero-mas#sumarme, #canjear, #invitar ... */
    var h = (window.location.hash || '').replace('#', '');
    if (HASH_VIEWS[h]) {
      setTimeout(function () { openProgram(HASH_VIEWS[h]); }, 1400);
      return;
    }

    /* aviso suave al entrar */
    var delay = Math.max(0, Number(root.getAttribute('data-hint-delay')) || 0) * 1000;
    if (root.getAttribute('data-hint') === '1' && mem('qm-hint-off') !== '1' && mem('qm-opened') !== '1') {
      setTimeout(function () { if (launcherVisible(launcher())) showCoach(false); }, delay);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();